var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "content-header row" }, [
      _c("div", { staticClass: "content-header-left col-md-9 col-12 mb-2" }, [
        _c("div", { staticClass: "row breadcrumbs-top" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", { staticClass: "content-header-title float-left mb-0" }, [
              _vm._v(
                _vm._s(_vm.trans("general.print")) + "\n                    "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "breadcrumb-wrapper col-12" }, [
              _c("ol", { staticClass: "breadcrumb" }, [
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm.user.profile
                  ? _c("li", { staticClass: "breadcrumb-item active" }, [
                      _vm._v(
                        _vm._s(
                          _vm.user.profile.first_name +
                            " " +
                            _vm.user.profile.last_name
                        ) +
                          " (" +
                          _vm._s(_vm.user.email) +
                          ")"
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-body" }, [
      _c("div", { staticClass: "card" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row mb-4" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-3" }, [
              _c("strong", [_vm._v("First Name:")]),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.profileForm.first_name || "Not provided"))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-3" }, [
              _c("strong", [_vm._v("Last Name:")]),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.profileForm.last_name || "Not provided"))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-3" }, [
              _c("strong", [_vm._v("Date of Birth:")]),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.profileForm.date_of_birth || "Not provided"))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-3" }, [
              _c("strong", [_vm._v("Gender:")]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "text-muted" },
                [
                  _vm.genders && _vm.profileForm.gender
                    ? [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.getGenderName(_vm.profileForm.gender)) +
                            "\n                            "
                        )
                      ]
                    : [_vm._v("Not provided")]
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-3" }, [
              _c("strong", [_vm._v("BVN:")]),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.profileForm.bvn || "Not provided"))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-3" }, [
              _c("strong", [_vm._v("Tax ID:")]),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(
                  _vm._s(
                    _vm.user && _vm.user.tax_id
                      ? _vm.user.tax_id
                      : "Not provided"
                  )
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-4" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-3" }, [
              _c("strong", [_vm._v("Address:")]),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.profileForm.address || "Not provided"))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-3" }, [
              _c("strong", [_vm._v("City:")]),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.profileForm.city || "Not provided"))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-3" }, [
              _c("strong", [_vm._v("State:")]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "text-muted" },
                [
                  _vm.states && _vm.profileForm.state_id
                    ? [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.getStateName(_vm.profileForm.state_id)) +
                            "\n                            "
                        )
                      ]
                    : [_vm._v("Not provided")]
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-3" }, [
              _c("strong", [_vm._v("LGA:")]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "text-muted" },
                [
                  _vm.lgas && _vm.profileForm.lga_id
                    ? [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.getLgaName(_vm.profileForm.lga_id)) +
                            "\n                            "
                        )
                      ]
                    : [_vm._v("Not provided")]
                ],
                2
              )
            ])
          ]),
          _vm._v(" "),
          _vm.profileForm.type === "business"
            ? _c("div", { staticClass: "row mb-4" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6 mb-3" }, [
                  _c("strong", [_vm._v("Business Name:")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-muted" }, [
                    _vm._v(
                      _vm._s(_vm.profileForm.business_name || "Not provided")
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6 mb-3" }, [
                  _c("strong", [_vm._v("Registered Name:")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-muted" }, [
                    _vm._v(
                      _vm._s(_vm.profileForm.registered_name || "Not provided")
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6 mb-3" }, [
                  _c("strong", [_vm._v("RC Number:")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.profileForm.rc_no || "Not provided"))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6 mb-3" }, [
                  _c("strong", [_vm._v("Company TIN:")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-muted" }, [
                    _vm._v(
                      _vm._s(_vm.profileForm.company_tin || "Not provided")
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6 mb-3" }, [
                  _c("strong", [_vm._v("Business Type:")]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "text-muted" },
                    [
                      _vm.businessTypes && _vm.profileForm.business_type_id
                        ? [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.getBusinessTypeName(
                                    _vm.profileForm.business_type_id
                                  )
                                ) +
                                "\n                            "
                            )
                          ]
                        : [_vm._v("Not provided")]
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6 mb-3" }, [
                  _c("strong", [_vm._v("Sector:")]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "text-muted" },
                    [
                      _vm.sectors && _vm.profileForm.sector_id
                        ? [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.getSectorName(_vm.profileForm.sector_id)
                                ) +
                                "\n                            "
                            )
                          ]
                        : [_vm._v("Not provided")]
                    ],
                    2
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-4" }, [
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-3" }, [
              _c("strong", [_vm._v("Occupation:")]),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.profileForm.occupation || "Not provided"))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-3" }, [
              _c("strong", [_vm._v("Employer Name:")]),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.profileForm.employer_name || "Not provided"))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-3" }, [
              _c("strong", [_vm._v("Employer TIN:")]),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.profileForm.employer_tin || "Not provided"))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-3" }, [
              _c("strong", [_vm._v("Nationality:")]),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.profileForm.nationality || "Not provided"))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-3" }, [
              _c("strong", [_vm._v("Tax Authority:")]),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.profileForm.tax_authority || "Not provided"))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-3" }, [
              _c("strong", [_vm._v("Last Updated By:")]),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.profileForm.updated_by || "Not provided"))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-3" }, [
              _c("strong", [_vm._v("Last Update Time:")]),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.profileForm.update_time || "Not provided"))
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "breadcrumb-item" }, [
      _c("a", { attrs: { href: "/" } }, [_vm._v("Home")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "breadcrumb-item" }, [
      _c("a", { attrs: { href: "/" } }, [_vm._v("Print")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", { staticClass: "card-title" }, [_vm._v("Profile Information")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h5", { staticClass: "section-title" }, [
        _vm._v("Personal Information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h5", { staticClass: "section-title" }, [
        _vm._v("Contact Information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h5", { staticClass: "section-title" }, [
        _vm._v("Business Information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h5", { staticClass: "section-title" }, [
        _vm._v("Employment Information")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h5", { staticClass: "section-title" }, [
        _vm._v("Additional Information")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }